<template>
  <div style="width: 500px;margin: 0px auto;">
    <div
      v-if="item.children != null"
      :style="indent"
    >
      <div
        :style="titleLabel"
      >
        {{ item.name }}
      </div>
      <el-input
        v-if="type === 'costEstimate'"
        :style="inputStyleCostEstimateTotal"
        :value="(item.costTotal / 10000).toFixed(4)"
        type="text"
        readonly
        autocomplete="off"
        :placeholder="'金额'"
      >
      </el-input>
      <el-input
        v-if="type === 'costEstimate'"
        :style="inputStyleCostEstimatePerUnit"
        v-model="item.cost"
        type="text"
        readonly=""
        autocomplete="off"
        :placeholder="'单方造价'"
        @blur="onCostValueChange"
      >
      </el-input>
      <el-input
        v-if="type === 'costEstimate'"
        :style="inputStyleCostEstimatePercent"
        v-model="item.costPercent"
        type="text"
        readonly
        autocomplete="off"
        :placeholder="'比例'"
      >
      </el-input>
    </div>
    <template v-else>
      <div :style="indent">
        <div
          v-if="type === 'costEstimate'"
          :style="titleLabelCostEstimate"
        >
          {{ item.name }}
        </div>
        <el-input
          v-if="type === 'costEstimate'"
          :style="inputStyleCostEstimateTotal"
          :value="(item.costTotal / 10000).toFixed(4)"
          type="text"
          readonly
          autocomplete="off"
          :placeholder="'金额'"
        >
        </el-input>
        <el-input
          v-if="type === 'costEstimate'"
          :style="inputStyleCostEstimatePerUnit"
          v-model="item.cost"
          type="text"
          autocomplete="off"
          :placeholder="'单方造价'"
          @blur="onCostValueChange"
        >
        </el-input>
        <el-input
          v-if="type === 'costEstimate'"
          :style="inputStyleCostEstimatePercent"
          v-model="item.costPercent"
          type="text"
          readonly
          autocomplete="off"
          :placeholder="'比例'"
        >
        </el-input>
        <el-checkbox
          v-model="item.checked"
          @change="forceUpdate"
          v-if="type === 'template'">
          <div :style="titleLabelNoTransform">
            {{ item.name }}
          </div>
        </el-checkbox>
        <div
          v-if="type === 'dataAdjust'"
          :style="titleLabelNoTransform"
        >
            {{ item.name }}
        </div>
        <i v-if="item.checked && type === 'template'"
          class="el-icon-circle-plus-outline"
          v-on:click="addMajorMaterial(item)"
          :style="plusBtnStyle"
        >
        </i>
        <el-input
          v-if="item.checked && type !== 'costEstimate'"
          v-model="item.cost"
          :style="inputStyle"
          type="text"
          autocomplete="off"
          placeholder="单方造价"
          @blur="onCostValueChange"
        >
        </el-input>
        <div :style="majorMaterialsStyle" v-if="item.checked && type !== 'costEstimate'">
          <template
              v-for="(materialItem, index) of item.majorMaterials">
            <div :key="'div-' + index" style="margin: 10px auto;">
                <el-select
                  v-if="type !== 'dataAdjust'"
                  :key="'material-' + index"
                  style="width: 250px;margin-right: 10px;"
                  filterable
                  v-model="materialItem.id"
                  placeholder="请选择主材">
                  <el-option
                    v-for="item in majorMaterialList"
                    :key="item.id"
                    :label="item.name + item.model"
                    :value="item.id">
                  </el-option>
                </el-select>
                <div
                  v-if="type === 'dataAdjust'"
                  style="width: 280px;margin-right: 10px;display: inline-block;">
                  <span
                    :key="'span-material-' + index"
                  >
                    ·{{majorMaterialLabel(materialItem.id)}}
                  </span>
                </div>
                <el-input
                  :key="'percent-' + index"
                  type="text"
                  @blur.native.capture="onMajorMaterialPercentChange"
                  @input="forceUpdate"
                  v-model="materialItem.percent"
                  autocomplete="off"
                  style="width: 80px;display: inline-block;"
                  placeholder="百分比">
                </el-input>
                <i
                  v-if="type !== 'dataAdjust'"
                  class="el-icon-remove-outline"
                  v-on:click="removeMajorMaterial(item, index)"
                  style="margin-left: 10px;font-size: 19px;">
                </i>
            </div>
          </template>
        </div>
      </div>
    </template>
    <div v-if="item.children != null">
      <tree-menu-project-item
        v-for="(childItem, index) of item.children"
        :key="index"
        :type="type"
        :item="childItem"
        :depth="depth + 1"
        :majorMaterialList="majorMaterialList"
        v-on:costChange="onCostValueChange"
      ></tree-menu-project-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeMenuProjectItem',
  props: {
    type: {
      type: String,
      default: ''
    },
    item: {},
    majorMaterialList: undefined,
    depth: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      showChildren: false,
      rules: {
        cost: [{ required: true, message: '单方造价不能为空', trigger: 'blur' }, { type: 'number', message: '请输入数字', trigger: 'blur, change' }]
      }
    }
  },

  methods: {
    forceUpdate () {
      this.$forceUpdate()
    },

    majorMaterialLabel (id) {
      if (this.$props.majorMaterialList) {
        for (var i = 0; i < this.$props.majorMaterialList.length; i++) {
          if (this.$props.majorMaterialList[i].id === id) {
            return this.$props.majorMaterialList[i].name + this.$props.majorMaterialList[i].model + '(%)'
          }
        }
      }
    },

    addMajorMaterial (item) {
      item.majorMaterials.push({})
      this.$forceUpdate()
    },

    removeMajorMaterial (item, index) {
      item.majorMaterials.splice(index, 1)
      this.$forceUpdate()
    },

    toggleChildren () {
      this.showChildren = !this.showChildren
    },

    onCostValueChange () {
      var reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/
      if (!reg.test(this.$props.item.cost)) {
        this.$props.item.cost = this.$props.item.lastCostValue
      } else {
        this.$props.item.cost = Number(this.$props.item.cost).toFixed(2)
        this.$props.item.lastCostValue = this.$props.item.cost
        this.$emit('costChange', '')
      }
    },

    onMajorMaterialPercentChange () {
      for (var i = 0; i < this.$props.item.majorMaterials.length; i++) {
        if (this.$props.item.majorMaterials[i].lastPercent !== this.$props.item.majorMaterials[i].percent) {
          var reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/
          if (!reg.test(this.$props.item.majorMaterials[i].percent)) {
            this.$props.item.majorMaterials[i].percent = this.$props.item.majorMaterials[i].lastPercent
          } else {
            this.$props.item.majorMaterials[i].percent = Number(this.$props.item.majorMaterials[i].percent).toFixed(2)
            this.$props.item.majorMaterials[i].lastPercent = this.$props.item.majorMaterials[i].percent
          }
          this.$forceUpdate()
          break
        }
      }
    }
  },

  mounted () {
    this.$props.item.lastCostValue = this.$props.item.cost
    for (var i = 0; i < this.$props.item.majorMaterials.length; i++) {
      this.$props.item.majorMaterials[i].lastPercent = this.$props.item.majorMaterials[i].percent
    }
  },

  computed: {
    titleLabel () {
      return {
        // fontSize: `${18 + this.depth}px`,
        width: '170px',
        fontSize: '19px',
        'font-weight': 'bold',
        color: '#000',
        display: 'inline-block'
      }
    },
    titleLabelNoTransform () {
      return {
        // fontSize: `${18 + this.depth}px`,
        fontSize: '19px',
        'font-weight': 'normal',
        color: '#000000',
        display: 'inline-block'
      }
    },
    indent () {
      return { transform: `translate(${this.depth * 20}px)`, 'margin-bottom': '10px' }
    },
    indentOpposite () {
      return { transform: `translate(${-this.depth * 20}px)` }
    },
    inputStyle () {
      return { width: '220px', float: 'right', transform: `translate(${-this.depth * 20}px)` }
    },
    titleLabelCostEstimate () {
      return {
        width: '170px',
        fontSize: '19px',
        'font-weight': 'normal',
        color: '#000000',
        display: 'inline-block'
      }
    },
    inputStyleCostEstimateTotal () {
      return {
        width: '150px',
        transform: `translate(${-this.depth * 20}px)`,
        'margin-left': '0px'
      }
    },
    inputStyleCostEstimatePerUnit () {
      return {
        width: '90px',
        transform: `translate(${-this.depth * 20}px)`,
        'margin-left': '10px',
        'margin-right': '10px'
      }
    },
    inputStyleCostEstimatePercent () {
      return {
        width: '70px',
        transform: `translate(${-this.depth * 20}px)`
      }
    },
    majorMaterialsStyle () {
      if (this.$props.type !== 'dataAdjust') {
        return { width: '370px', transform: `translate(${130 - this.depth * 20}px)` }
      }
      return { width: '370px', transform: `translate(${130 - this.depth * 20}px)` }
    },
    plusBtnStyle () {
      return { 'margin-left': '5px', 'font-size': '19px' }
    }
  }
}
</script>
<style scoped>
/* .inputStyleCostEstimateTotal.el-input__inner {
  text-align: 'center'
} */
</style>
